// extracted by mini-css-extract-plugin
export default {"HeaderComponent":"ForumCategoryHeader_HeaderComponent__omMjF","InfoCourse":"ForumCategoryHeader_InfoCourse__N+WNp"};